import { HeaderMobile } from './HeaderMobile';

export * from './HeaderMobile';

export default HeaderMobile;
